<template>
  <div class="video-uploader">
    <el-upload
      :action="''"
      :http-request="onHttpRequest"
      :file-list="fileList"
      :limit="1"
      :accept="'.mp4'"
      :before-upload="beforeUpload"
      :on-exceed="onExceed"
      :on-remove="onRemove"
      :auto-upload="true"
      list-type="text"
    >
      <el-button size="small" type="primary">选择视频文件</el-button>
      <div slot="tip" class="el-upload__tip">
<!--        <el-progress-->
<!--          v-if="uploading"-->
<!--          :percentage="uploadProgress"-->
<!--          :stroke-width="18"-->
<!--          :text-inside="true"-->
<!--          style="margin: 8px 0"-->
<!--        />-->
        <div class="text">仅支持 mp4 格式，最大 700MB</div>
      </div>
    </el-upload>
  </div>
</template>

<script>
    // 假设你封装了 API 请求，例如在 api_index.js 中
    import { fetchUploadVideoDirect } from "@/request/api_index.js";
    import {captureFrame} from "./captureFrame";

    export default {
        name: "VideoUploader",
        props: {
            // 支持 v-model 绑定文件列表
            value: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                fileList: [],
                uploading: false,
                uploadProgress: 0
            };
        },
        watch: {
            value: {
                immediate: true,
                handler(val) {
                    this.fileList = val || [];
                }
            }
        },
        methods: {
            /**
             * 上传前校验
             */ async beforeUpload(file) {

                const isMP4 = file.name.endsWith(".mp4") || file.type === "video/mp4";
                if (!isMP4) {
                    this.$message.error("仅支持上传 MP4 格式的视频文件！");
                    return false;
                }

                const maxSize = 1024 * 1024 * 700; // 700MB
                if (file.size > maxSize) {
                    this.$message.error("视频文件大小不能超过 700MB！");
                    return false;
                }

                // try {
                    let frame = await captureFrame(file, 1);
                    this.$emit("getVideoimage", frame);
                // } catch (error) {
                //     this.$message({
                //         message: "视频解析失败",
                //         type: "warning"
                //     });
                // }
                // console.log(fileInfo);
                // ✅ 返回 true，继续执行 http-request
                return true;
            },

            /**
             * 文件超出个数限制
             */
            onExceed() {
                this.$message.warning("最多只能上传一个视频文件");
            },

            /**
             * 删除文件
             */
            onRemove() {
                this.$emit("update:value", []);
                this.$message.info("已删除文件");
            },

            /**
             * 自定义上传逻辑
             */
            async onHttpRequest({ file, onProgress, onSuccess, onError }) {
                const formData = new FormData();
                formData.append("file", file); // 后端通过 $_FILES['video'] 获取


                this.uploading = true;
                this.uploadProgress = 0;

                try {
                    const res = await fetchUploadVideoDirect({
                        data: formData,
                        isLoading: false, // 控制是否显示 loading
                        onUploadProgress: (progressEvent) => {
                            const percent = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
                            this.uploadProgress = percent;
                            onProgress({ percent }); // Element UI 进度条回调
                        }
                    });

                    if (res.code === 200) {
                        const videoInfo = res.data;
                        const uploadedFile = {
                            name: videoInfo.name,
                            url: videoInfo.url,
                            src: videoInfo.url
                        };
                        this.$emit("update:value", [uploadedFile]);
                        onSuccess(res, file); // 触发 el-upload 成功钩子
                        this.$message.success("上传成功");
                    } else {
                        onError(new Error(res.msg || "上传失败"));
                    }
                } catch (err) {
                    console.error("[上传失败]", err);
                    this.$message.error("上传失败：" + (err.message || "网络错误"));
                    onError(err);
                } finally {
                    this.uploading = false;
                }
            }
        }
    };
</script>

<style scoped>
  .video-uploader {
    font-size: 14px;
  }
  .text {
    color: #999;
    font-size: 12px;
    margin-top: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ChunkUpload/index.vue